export const tenantConstants = {
    xtenantid: 'X-ARCAuthTenantID',
    tenantValue: 'e0f727de-6882-4617-94f3-87c34bc005c8'
  };